import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { getRiveHomeSrc, riveHomeBufferQuery } from './RiveHomeView';
import { useSessionTimeOfDay } from './sessionTimeOfDay';

export const usePrefetchRiveHome = (enabled: boolean, snow: boolean, coordinates?: { lat: number; lng: number }) => {
  const queryClient = useQueryClient();
  const timeOfDay = useSessionTimeOfDay(coordinates);

  useEffect(() => {
    if (enabled && coordinates) {
      queryClient.prefetchQuery(riveHomeBufferQuery(getRiveHomeSrc(timeOfDay, snow)));
    }
  }, [enabled, snow, coordinates, timeOfDay, queryClient]);
};
